export default "__VITE_ASSET__DdPbvIfF__"